module.exports = __webpack_public_path__ + "loader@1x.da5afed58d4a7ab9e44a16ee5387707b.gif";